import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { getSubCategoryApi, deleteSubCategoryApi, updateSubCategoryApi } from "./SubCategory.action";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from 'material-table';
import jsPDF from "jspdf";
const tableRef = React.createRef()


const SubCategoryTableList = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"))
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
    }

    useEffect(() => {
        props.setHeading("Sub-Category List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    title="Sub-Category List"
                    columns={[
                        { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Company Name', field: 'retaurantId.restaurantName', editable: 'never' },
                        { title: 'Category Name', field: 'categoryId.name', editable: 'never' },
                        { title: 'Sub-Category Name', field: 'subCategoryName' },
                        { title: 'Created At', field: 'createdAt', type: 'date', editable: 'never', dateSetting: { locale: "en-GB" } },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/sub_category?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: 'GET',
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "p";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Sub-Category Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.retaurantId.restaurantName,
                                elt.categoryId.name,
                                elt.subCategoryName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Sub-Category Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Sub Category Edit"),
                        isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Sub Category Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.updateSubCategoryApi(newData, oldData)
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.deleteSubCategoryApi(oldData._id);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        }
                    ]}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        deleteSubCategoryApi: (_Id) => dispatch(deleteSubCategoryApi(_Id)),
        updateSubCategoryApi: (newData, oldData) => dispatch(updateSubCategoryApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SubCategoryTableList);